module.exports = __webpack_public_path__ + "assets/img/microscope.09c8ca02.svg";